/**
 *
 * @param {string} path
 */
export default path => obj => {
  const chunks = path.split('.').reverse();
  let chunk, current;

  for (chunk = chunks.pop(), current = obj; chunk; chunk = chunks.pop()) {
    current = current[chunk];

    if (! current) return current;
  }

  return current;
};
